import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { addressCheckPagePath, investigationsPagePath } from '@/config';

import styles from './AMLCheckTabs.module.sass';

type AMLCheckTabsKeys =
  | typeof addressCheckPagePath
  | typeof investigationsPagePath;

interface AMLCheckTabsProps {
  activeKey: AMLCheckTabsKeys;
}

const AMLCheckTabs = ({ activeKey }: AMLCheckTabsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const tabs: TabsProps['items'] = [
    {
      key: addressCheckPagePath,
      label: (
        <span className={styles.tab}>{t('translation.check_address')}</span>
      ),
    },
    {
      key: investigationsPagePath,
      label: (
        <span className={styles.tab}>{t('translation.investigations')}</span>
      ),
    },
  ];

  return (
    <Tabs
      defaultActiveKey={activeKey}
      size="large"
      items={tabs}
      tabBarGutter={0}
      animated={false}
      onChange={(key) => navigate(key)}
    />
  );
};

export default AMLCheckTabs;
